import React, { useState, useEffect } from 'react';
import VideoPlayer from '../components/VideoPlayer';
import LoginPopup from '../components/Login'; // varsa
import { useNavigate } from 'react-router-dom';
import "../styles/Login.css";
import UyariPopup from '../components/UyariPopup';
const Home = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showKanGrubuPopup, setShowKanGrubuPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("showKanGrubuPopup") === "true") {
      setShowKanGrubuPopup(true);
      sessionStorage.removeItem("showKanGrubuPopup");
    }
  }, []);

  useEffect(() => {
    document.body.classList.add("home-video-page");
    document.documentElement.classList.add("home-video-html");

    return () => {
      document.body.classList.remove("home-video-page");
      document.documentElement.classList.remove("home-video-html");
    };
  }, []);

  const handleKanGrubuTamam = () => {
    sessionStorage.setItem("focusKanGrubu", "true");
    setShowKanGrubuPopup(false);
    navigate("/ozgecmisim");
  };

  const handleOpenLogin = () => {
    setShowLoginPopup(true);
  };

  const handleCloseLogin = () => {
    setShowLoginPopup(false);
  };

  return (
    <>
      {showKanGrubuPopup && (
        <div className="kan-popup-overlay">
          <div className="kan-popup-box">
            <h3>Eksik Bilgi</h3>
            <p>Lütfen eksik bilgilerinizi doldurunuz.</p>

            <button onClick={handleKanGrubuTamam}>
              Tamam
            </button>
          </div>
        </div>
      )}
      <VideoPlayer openLoginPopup={handleOpenLogin} />

      {showLoginPopup && <LoginPopup onClose={handleCloseLogin} />}
    </>
  );
};

export default Home;
